/**
 * UI-only display mapping for team role names.
 *
 * Stored role names are NOT changed: the backend (QUALITY_REVIEW_ROLE_NAMES in
 * views/project_iq/workspaces.py) and useQualityReviewAccess still match on
 * "Engagement Leader". Only the label shown to users on the People and Project
 * Reviews pages is "Engagement Lead".
 */
const ROLE_DISPLAY_NAMES: Record<string, string> = {
  "Engagement Leader": "Engagement Lead",
};

export const getRoleDisplayName = (roleName: string): string =>
  ROLE_DISPLAY_NAMES[roleName] ?? roleName;
